module.exports = __webpack_public_path__ + "img/font_freestyle-script.6e86b37.svg";